import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid, GridFooterContainer, GridPagination, GridToolbarColumnsButton, GridToolbarExportContainer, GridToolbarQuickFilter} from '@mui/x-data-grid';
import { callPostApi } from '../../API/ApiCallFunction';
import { Button } from '@mui/material'
import { AddCircleOutline, CurrencyRupee, RemoveCircleOutline } from '@mui/icons-material';


const ApiList = () => {

    const [allData,        setAllData]        = useState([]);
    const [loading,        setLoading]        = useState(false);
    const [pageIndex,      setPageIndex]      = useState(0);
    const [hasMoreData,    setHasMoreData]    = useState(true);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filtersLoaded,  setFiltersLoaded]  = useState(false);
    
    const isInitialSessionLoad = useRef(false);
    const hasFetchedRef        = useRef(false);

    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const store_id = user.store_info.store_id;
      
    // Default Filter For Searching
    const defaultFilters = useMemo(() => ({store_id, fetchLimit: '10', pageSize: '10' }), [store_id]);
    const [filters, setFilters] = useState(defaultFilters);

    // Reset Data States
    const resetDataStates = () => {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setLoading(false);
    };

    // Apply Filters
    const applyFilters = () => 
    {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setFiltersApplied(true);
    };

    // Clear Filters
    const clearFilters = () => 
    {
        setFilters(defaultFilters);
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        sessionStorage.setItem('apiListFilters', JSON.stringify(defaultFilters));
        setFiltersApplied(true);
         fetchData();
         
    };

    // Load from sessionStorage
    useEffect(() => 
    {
        const storedState = sessionStorage.getItem('apiListFilters');
        if (storedState) 
        {
            try 
            {
                const parsedState = JSON.parse(storedState);
                setFilters({ ...defaultFilters, ...parsedState });
                isInitialSessionLoad.current = true;
                // setFiltersApplied(true);
            } 
            catch (error) 
            {
          
                sessionStorage.removeItem('apiListFilters');
            }
        }
    }, [defaultFilters]);

    // Fetch Data Function
    const fetchData = useCallback(async (page = pageIndex) => 
    {
    
        if (!filtersLoaded || loading || !hasMoreData) return;

        setLoading(true);
        try 
        {
            const StartNum = page * filters.fetchLimit;
            const payload = {mod: "STORE_WALLET_HISTORY", data_arr: {...filters,start: StartNum,limit: filters.fetchLimit,}};
            
            const response = await callPostApi('store-wallet', payload);

    
            if (response.status === '200' && response.data) 
            {
                const apiResponse = response.data
                setAllData(prev => [...prev, ...apiResponse]);
                setPageIndex(page);

                if (apiResponse.length < filters.fetchLimit) { setHasMoreData(false); }
            } 
            else 
            {
                resetDataStates();
                setHasMoreData(false);
            }
        } 
        catch (error) { resetDataStates(); } 
        finally { setLoading(false); }

    }, [filters, filtersLoaded, loading, hasMoreData, pageIndex]);

    // Initial fetch trigger
    
     useEffect(() => { if (!filtersLoaded) setFiltersLoaded(true); }, [filtersLoaded]);
    // Save to sessionStorage
    useEffect(() => {
         if (!hasFetchedRef.current && filtersLoaded) {
            hasFetchedRef.current = true;
            fetchData();
        }
     
        if (filtersApplied) 
        {
            sessionStorage.setItem('apiListFilters', JSON.stringify(filters));
            if (!isInitialSessionLoad.current) { fetchData(0); }
            isInitialSessionLoad.current = false;
            setFiltersApplied(false);
        }
        const handleExternalRefresh = () => {
               resetDataStates();
               hasFetchedRef.current = false;
            //    setFiltersApplied(true);
               fetchData(0);
           };
           window.addEventListener('refreshPriceTable', handleExternalRefresh);
           return () => window.removeEventListener('refreshPriceTable', handleExternalRefresh);
    }, [filtersLoaded, filtersApplied, filters,fetchData]);
    
    const CustomToolbar = () => {
        return (
            <GridToolbarExportContainer sx={{ justifyContent: 'space-between', px: 2, py: 1 }}>
                <GridToolbarColumnsButton /><GridToolbarQuickFilter debounceMs={300} />
            </GridToolbarExportContainer>
        );
    };

    const CustomFooterWithLoadMore = ({ hasMoreData, loading, onLoadMore }) => (
      <GridFooterContainer sx={{ px: 2, py: 1, overflowX: 'hidden', }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', width: '100%', }} >
          
              {/* Left: Rows per page */}
              <Box sx={{ flex: 1 }} />
              {/* Center: Load More */}
              
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {hasMoreData ? (
                      <Button variant="contained" onClick={onLoadMore} disabled={loading} sx={{ minWidth: 120 }}>
                          {loading ? 'Loading...' : 'Load More'}
                      </Button>
                  ) : (<Typography variant="body2" color="text.secondary">No more records </Typography>)}
              </Box>

              {/* Right: Pagination - Increased width */}
              <Box sx={{ flex: 2, minWidth: 250, display: 'flex', justifyContent: 'flex-end' }}>
                  <GridPagination />
              </Box>
              
          </Box>
      </GridFooterContainer>
      );
    
    return (
    <div>


        <div className='mb-3'>
            
            {/* Row for Download Excel button */}
           

            {/* Filter Inputs and Apply Filters button */}
            <div className="row align-items-center g-2 searchFilter">
                               
                {/* Page Size Filter */}  
                <div className="col-12 col-md-2">
                    <select className="form-control" value={filters.fetchLimit} onChange={(e) => setFilters(prev => ({ ...prev, fetchLimit: e.target.value }))} >
                        <option value="">Record Fetch Limit</option>
                        {[{value: '10', label: '10'},{value:'20',label: '20' }].map(o => ( <option key={o.value} value={o.value}>{o.label}</option> ))}
                    </select>
                </div>    

              
                {/* Apply flter */}
                <div className="col-12 col-md-10 d-flex justify-content-end">                                            
                    <Button  sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#ffffff',ml:1,
                    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
                   }}
                  style={{float: 'right'}} 
                        onClick={() => { resetDataStates(); fetchData(0); applyFilters(); }} >Apply Filters</Button>
                    <Button sx={{background:'linear-gradient(195deg, #42424a, #191919)', color:'#ffffff',ml:1,
                    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
                   }} style={{float: 'right'}} onClick={clearFilters}>Clear Filters</Button>
                </div>
                

                
            </div>
        </div>
        
        <Box sx={{ height: 'auto', width: '100%' }}>
            <DataGrid rows={allData.map((row, i) => ({...row,srNo: i + 1 ,id: row.row_temp_id || `${pageIndex}-${i}`}))}
                columns={[
                    { field: 'srNo', headerName: 'Sr. No.', flex: 0.5, sortable: false, filterable: false,},
                    {
                          field: 'opening_balance', headerName: 'Opening Balance', flex:  1, minWidth: 120,
                          renderCell: (params) => (
                            <>
                              <CurrencyRupee sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '16px', mb: '2px' }} />
                              {params.value}
                            </>
                          ),
                        }, 
                        {
                          field: 'wallet_amount', headerName: 'Transactions', flex:  1, minWidth: 120,
                          renderCell: (params) => {
                              const isAdd = params.row.wallet_action === 'Add';
                              const isSub = params.row.wallet_action === 'Sub';
                            return(
                              <>
                               <Box sx={{ display: 'flex', alignItems: 'center', color: isAdd ? 'green' : isSub ? 'red' : 'inherit' }}>
                                {isAdd && <AddCircleOutline sx={{ fontSize: 18, mr: 0.5 }} />}
                                {isSub && <RemoveCircleOutline sx={{ fontSize: 18, mr: 0.5 }} />}
                                <CurrencyRupee sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '16px', mb: '2px' }} />
                                {params.value}
                              </Box>
                            </>           
                            )
                           
                          },
                        }, 
                        {
                          field: 'closing_balance', headerName: 'Closing Balance', flex: 1, minWidth: 120,
                          renderCell: (params) => (
                            <>
                              <CurrencyRupee sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '16px', mb: '2px' }} />
                              {params.value}
                            </>
                          ),
                        },
                        {
                          field: 'comment', headerName: 'Remarks', flex: 2, minWidth: 120,      
                        },
                        {
                          field: 'date_added', headerName: 'Date', flex: 1, minWidth: 120,
                        },
                    
                  ]}

                pageSize={Number(filters.pageSize)}
                onPageSizeChange={(newSize) => setFilters((prev) => ({ ...prev, pageSize: String(newSize) })) }
                pageSizeOptions={[10, 15, 20, 25, 40, 50, 80, 100]}
                pagination
                
                disableSelectionOnClick
                initialState={{pagination: {paginationModel: {pageSize: Number(filters.pageSize),page: 0,},},}}
                slots={{toolbar: CustomToolbar, footer: () => ( <CustomFooterWithLoadMore onLoadMore={() => fetchData(pageIndex + 1)} hasMoreData={hasMoreData} loading={loading} /> ), }}
                slotProps={{toolbar: {showQuickFilter: true,quickFilterProps: { debounceMs: 300 },},}}
                sx={{ '& .MuiDataGrid-cell': {fontSize: '13px', }, 
                    '& .MuiDataGrid-columnHeaderTitle': {fontSize: '15px',fontWeight: 'bold', whiteSpace: 'normal !important', 
                            lineHeight: '1.5', textAlign: 'center',},
                        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {outline: "none"} }}
                rowHeight={38} headerHeight={45}
                
            />
        </Box>

    </div>
  );
};

export default ApiList;